<app-base-side-panel-modal class="h-dvh">
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-7 h-7 svg-dark" [src]="'edit'"></svg-icon>

      <div class="text-navy-90">
        {{ buildTranslationKey('control.edit') | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="flex p-4 flex-col justify-end items-start self-stretch rounded-md bg-navy-20">
      <span class="text-navy-90 text-sm font-bold">{{ buildTranslationKey('control.name') | translate }}</span>
      <div class="p-2 text-navy-70 text-base font-normal">{{ control.name }}</div>
    </div>

    <div class="flex flex-col gap-2 p-5">
      <span class="text-navy-90 font-bold text-2xl">
        {{ buildTranslationKey('control.requirements') | translate }} ({{ control.requirements.length }}):
      </span>

      <app-radio-button-group
        class="radio-buttons"
        [class.not-monitored]="!monitoredIndicationDisplayingControl.value"
        [label]="buildTranslationKey('monitoredIndicationRadioGroup.showMonitoredIndication')"
        [labelWithColon]="false"
        [isLabelBold]="false"
        [buttons]="monitoredIndicationRadioButtons"
        [formControl]="monitoredIndicationDisplayingControl"
      ></app-radio-button-group>

      <app-radio-button-group
        class="radio-buttons"
        [label]="buildTranslationKey('linkedFrameworksRadioGroup.showLinkedFrameworks')"
        [labelWithColon]="false"
        [isLabelBold]="false"
        [buttons]="linkedFrameworksRadioButtons"
        [formControl]="linkedFrameworksDisplayingControl"
      ></app-radio-button-group>
    </div>

    <div class="flex flex-col px-5">
      @for (requirement of requirements; track requirement.id) {
        <div class="border-t border-navy-40 py-5 pb-6">
          <app-requirement-edit
            #requirementEditor
            [showMonitoredIndication]="monitoredIndicationDisplayingControl.value"
            [requirement]="requirement"
            [displayLinkedFrameworks]="linkedFrameworksDisplayingControl.value"
          ></app-requirement-edit>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="flex gap-2">
      <app-new-button
        class="checkmark-button"
        [saveButtonSizeDuringLoading]="true"
        [type]="'primary'"
        [svgIconPath]="'checkmark'"
        [size]="'responsive'"
        [loading]="sendingRequestBtnLoader$ | async"
        [disabled]="!canSave"
        (click)="saveBtnClick()"
      >
        {{ buildTranslationKey('saveChangesBtn') | translate }}
      </app-new-button>

      <app-new-button [size]="'responsive'" [type]="'secondary'" (click)="cancel()">
        {{ buildTranslationKey('cancel') | translate }}
      </app-new-button>
    </div>
  </ng-template>
</app-base-side-panel-modal>
